import React from 'react';
;


const Message = () => {
  return <div>
      {/* <SmsTracking size="24" color="white" variant="Bold"/> */}
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="vuesax_bold_sms-tracking" data-name="vuesax/bold/sms-tracking" transform="translate(-620 -252)">
          <g id="sms-tracking">
            <path id="Vector" d="M0,0H24V24H0Z" transform="translate(620 252)" fill="none" opacity="0"/>
            <path id="Vector-2" data-name="Vector" d="M5,0a5,5,0,1,0,5,5A5,5,0,0,0,5,0ZM2.96,2.96H5A.68.68,0,1,1,5,4.32H2.96a.68.68,0,1,1,0-1.36ZM7.04,7.04H2.96a.68.68,0,0,1,0-1.36H7.05a.681.681,0,0,1,.68.68A.689.689,0,0,1,7.04,7.04Z" transform="translate(621 265)" fill="#fff"/>
            <path id="Vector-3" data-name="Vector" d="M15,0H5C2,0,0,1.5,0,5V8.14a1,1,0,0,0,1.42.9,6.509,6.509,0,0,1,3.66-.45,6.539,6.539,0,0,1,5.29,5.1,6.608,6.608,0,0,1,.07,2.21.993.993,0,0,0,.99,1.11H15c3,0,5-1.5,5-5V5C20,1.5,18,0,15,0Zm.47,5.59-3.13,2.5a3.861,3.861,0,0,1-4.68,0L4.53,5.59a.769.769,0,0,1-.12-1.06.748.748,0,0,1,1.05-.12l3.13,2.5a2.386,2.386,0,0,0,2.81,0l3.13-2.5a.738.738,0,0,1,1.05.12A.759.759,0,0,1,15.47,5.59Z" transform="translate(622 255)" fill="#fff"/>
          </g>
        </g>
      </svg>

  </div>;
};

export default Message;
